export const AD_CONFIG = {
  desktop: {
    leaderboard: {
      width: 728,
      height: 90,
      key: '3133cea76cf33a12da3b7cdefe1aa41f'
    },
    banner: {
      width: 468,
      height: 60,
      key: '8f445a4b853e4109e0d682e5aa595327'
    },
    rectangle: {
      width: 300,
      height: 250,
      key: 'afac4dbd97c746249bb2082a9f0e42f3'
    },
    skyscraper: {
      width: 160,
      height: 300,
      key: '67bdc6d1a96c11f7f924465e8d59764e'
    }
  },

  mobile: {
    banner: {
      width: 320,
      height: 50,
      key: 'ebb4d389aa7d2095786a976b9e0e93d1'
    },
  }
};
